export default __webpack_public_path__ + "static/Plots0059-c20a06942dd284724d5e15ea43bc9adf.jpg";